module.exports = __webpack_public_path__ + "static/media/Footer_mobile.545746f3.jpg";